import React, { useContext, useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import { useNavigate } from "react-router";
import { CreativeContext } from "./CreativeCreation";
import { SlProgressBar } from '@shoelace-style/shoelace/dist/react';
import { classifiedSectionCategories } from "../../utils/constants";
import { SlDrawer } from '@shoelace-style/shoelace/dist/react';

function RecImage({
    company,
    companyName,
    handleshow,
    // advId,
    creative_name,
    creative_type,
    subtype,
    editdata,
    flag,
    handlesubmit,
    createdEdited
  }) {
    const navigate = useNavigate();
  
    const { preview, setPreview } = useContext(CreativeContext);
    const [progress, setProgress] = useState(0);
  
    const [imgurl, setImgurl] = useState("");
    const [initiator, setInitiator] = useState("")
  
    const [image, setImage] = useState("");

    
    
    const imageChange = async (e, initiator='image') => {
      setInitiator(initiator)
      if (e.target.files && e.target.files.length > 0) {
        if (e.target.files[0].type === "image/jpg" || e.target.files[0].type === "image/jpeg" || e.target.files[0].type === "image/webp" || e.target.files[0].type === "image/png") {
          setImage(e.target.files[0]);
        } else {
          Toast("error", "Only jpg, jpeg, webp, png formats accepted")
          setValue("image", "")
        }
      } else {
        if (flag === "edit") {
          if(initiator === "image"){
            setImgurl("")
            setImgurl(editdata.img_urls);
            setPreview(prev => ({ ...prev, img_urls: editdata.img_urls }));
          }
        } else {
          setProgress(0);
          if(initiator === "image"){
            setImgurl("");
            setPreview(prev => ({ ...prev, img_urls: ""}));
          }
        }
      }
    };

  
    const {
      register,
      handleSubmit,
      setValue,
      watch,
      formState: { errors },
    } = useForm({ mode: "onSubmit" });
    const formData = new FormData();
    formData.append("files", image);
    const imageUrl = async () => {
      try {
        let url = await api({
          url: `/upload/brandImage`,
          method: "POST",
          responseType: "json",
          data: formData,
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: data => {
            setProgress(Math.round((100 * data.loaded) / data.total))
          },
        });
        if (url.code === 200) {
          if(initiator === "image"){
            setImgurl(url.data?.data);
            setPreview({ ...preview, img_urls: url.data?.data, sub_type:"rec_image" });
          }
        } else {
          setProgress(0);
          setValue(initiator, null);
          if (flag === "edit") setImage("");
          Toast("error", url.data.message);
        }
      } catch (error) {
        Toast("error", error);
      }
    };
    useEffect(() => {
      if (image) {
        imageUrl();
      }
    }, [image]);

    useEffect(()=>{
      setPreview(prev => ({ ...prev, img_urls: imgurl }));
    },[imgurl])
    
    
  
    useEffect(() => {
      if (flag === "edit") {
        setPreview(prev => ({
          ...prev ,
          sub_type: editdata.sub_type,
          img_urls: editdata.img_urls,
        }));
      }
      setPreview(prev => ({...prev, sub_type: "rec_image" }));
    }, [company]);
  
  
  
    const onSubmit = async (data) => {
      if (flag === "add") {
        handlesubmit(true);
        let obj = {
          company_id: company,
          company_name: companyName,
          creative_name,
          creative_type,
          sub_type: subtype,
          img_url: imgurl,
          clickurl: data.clickurl,
          impurl: { primary: data.impurl, secondary: data.impurl1 }
  
        };
        // if (advId !== "" && creative_name !== "") {
        if (creative_name !== "") {
          try {
            let res = await api({
              url: `/creatives/recads/rec_image`,
              method: "POST",
              responseType: "json",
              data: obj,
            });
            if (res?.code === 200) {
              Toast("success", " Creative Created Successfully  ");
              handleshow(false);
              createdEdited(true);
            } else {
              Toast("error", res.data.message);
            }
          } catch (error) {
            console.error(error);
            if (error.response.status === 401) navigate("/");
          }
        }
      } else if (flag === "edit") {
        let obj = {
          creative_id: editdata.creative_id,
          creative_name: creative_name,
          clickurl: data.clickurl,
          impurl: { primary: data.impurl, secondary: data.impurl1 },
          
        };
        imgurl !== "" ? (obj.img_url = imgurl) : (obj.img_url = editdata.img_urls);
        try {
          let res = await api({
            url: `/creatives/recads/editrec_image`,
            method: "POST",
            responseType: "json",
            data: obj,
          });
          if (res?.code === 200) {
            Toast("success", " Creative Edited Successfully  ");
            handleshow(false);
            createdEdited(true);
          } else {
            Toast("error", res.data.message);
  
          }
        } catch (error) {
          console.error(error);
          if (error.response.status === 401) navigate("/");
        }
      }
    };  
  
    return (
      <>
        <div className="row">
          <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
            <div className="row">
              <section className="col-12">
                <div className="mb-3">
                  <label className="form-label">Image</label><br />
                  <span>(Image width should be greater than height )</span>
                  <input
                    className="form-control mb-2"
                    type="file"
                    id="formFile"
                    name="files"
                    {...register("image", {
                      required: false,
                      onChange: (e) => imageChange(e),
                    })}
                  />
                  {errors.image && (
                    <p className="text-red-600">Image is mandatory</p>
                  )}
                  {
                    progress > 0 && progress < 100 ? <SlProgressBar value={progress}>{progress}%</SlProgressBar> : imgurl !== "" ? (
                      <span>{`${imgurl}`}</span>
                    ) : (
                      flag === "edit" && <span>{`${editdata.img_urls}`}</span>
                    )}
                </div>
                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">Click URL / Mobile Number</label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={editdata.click_url !== '12' ? editdata.click_url : ''}
                      name="clickurl"
                      {...register("clickurl", {
                        required: false,
                        pattern: {
                          value:
                         /^((https?|ftp):\/\/[^\s\/$.?#].[^\s]*)$|^(www\.[^\s\/$.?#].[^\s]*)$|^([6-9]\d{9})$|^(0[6-9]\d{9})$/,
                          message: "Enter a Valid URL or Mobile Number",
                        },
                      })}
                    />
                    {errors.clickurl && (
                      <p className="text-red-600">{errors.clickurl.message}</p>
                    )}
                  </div>
                  <div className="col">
                    <label className="form-label">Impression URL - Primary</label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={
                        editdata.impression_tracking_url
                          ? editdata.impression_tracking_url.primary
                          : null
                      }
                      {...register("impurl", {
                        required: false,
                        pattern: {
                          value:
                            /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                          message: "Enter a Valid URL",
                        },
                      })}
                    />
                    {errors.impurl && (
                      <p className="text-red-600">{errors.impurl.message}</p>
                    )}
                  </div>
                  <div className="col">
                    <label className="form-label">
                      Impression URL - Secondary
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={
                        editdata.impression_tracking_url
                          ? editdata.impression_tracking_url.secondary
                          : null
                      }
                      {...register("impurl1", {
                        required: false,
                        pattern: {
                          value:
                            /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                          message: "Enter a Valid URL",
                        },
                      })}
                    />
                    {errors.impurl1 && (
                      <p className="text-red-600">{errors.impurl1.message}</p>
                    )}
                  </div>
                </div>
                <section>
              </section>
                <div className="my-3 text-end">
                  <button type="submit" className="btn btn-primary" disabled={(progress > 0 && progress < 100) ? true : false}>
                    Save Creative
                  </button>
                </div>
              </section>
            </div>
          </form>
        </div>
      </>
    );
  }

export default RecImage